import React, {useContext, useEffect, useState} from 'react';
import { fetchAffiliateLogs } from '../../http/userLogAPI';
import { Button, Table, Spinner, Collapse } from 'react-bootstrap';
import {FaSyncAlt, FaTable, FaUser} from 'react-icons/fa';
import Loader from "../Loader";
import {Context} from "../../index";

const AffiliateLogsTree = ({ userId }) => {
    const { user } = useContext(Context);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedLogs, setExpandedLogs] = useState({});
    const [expandedUsers, setExpandedUsers] = useState({});
    const [filters, setFilters] = useState({
        page: 1,
        limit: 10,
        fromDate: '',
        toDate: '',
        minReward: 0,
    });
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetchAffiliateLogs(userId, filters); // 👈 правильно передаём
            setData(response.tree || []);
        } catch (error) {
            console.error('Failed to fetch affiliate logs:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const toggleLogs = (key) => {
        setExpandedLogs(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const toggleUserBranch = (key) => {
        setExpandedUsers(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const calculateTotalReward = (logs, levelUp) => {
        const key = `ref_level${levelUp}_reward`;
        return logs.reduce((sum, log) => sum + (log[key] || 0), 0).toFixed(2);
    };

    const formatDate = (dateStr) => {
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, '0');
        const month = d.toLocaleString('en-US', { month: 'short' });
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const mins = String(d.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${mins}`;
    };

    const renderLogs = (logs, levelUp) => {
        const isMobile = window.innerWidth < 768;
        const planKey = `reward_plan_type_levelUp${levelUp}`;
        const rewardKey = `ref_level${levelUp}_reward`;
        const rewardPercentKey = `ref_level${levelUp}_percent`;

        const totalAmount = logs.reduce((sum, log) => sum + (log.subtotal_amount || 0), 0);
        const totalFee = logs.reduce((sum, log) => sum + (log.stripe_fee || 0), 0);
        const totalNet = logs.reduce((sum, log) => sum + (log.net_amount || 0), 0);
        const totalReward = logs.reduce((sum, log) => sum + (log[rewardKey] || 0), 0);

        if (isMobile) {
            return (
                <div className="d-flex flex-column gap-2 ms-2 mt-2">
                    {logs.map(log => (
                        <div key={log.id} className="border small rounded bg-light p-2 shadow-sm">
                            <div className="small text-muted"><strong>Date:</strong> {formatDate(log.user_transaction_date)}</div>
                            <div className="small text-muted"><strong>Type:</strong> {log.user_transaction_type.slice(0,28)}</div>
                            <div className="small text-muted"><strong>Amount:</strong> ${log.total_amount?.toFixed(2)} / <strong>Fee:</strong> ${log.stripe_fee?.toFixed(2)} / <strong>Net:</strong> ${log.net_amount?.toFixed(2)}</div>
                            <div className="small text-muted"></div>
                            <div className="small text-muted"></div>
                            <div className="small text-muted"><strong>Plan:</strong> {log[planKey] || '-'} / <strong>%:</strong> {log[rewardPercentKey]?.toFixed(2) || '0.00'}% / <strong>Reward:</strong> ${log[rewardKey]?.toFixed(2) || '0.00'}</div>
                            <div className="small text-muted"></div>
                            <div className="small text-muted"></div>
                        </div>
                    ))}

                    <div className="text-success small fw-bold ms-1">
                        TOTAL REWARD: ${totalReward.toFixed(2)}
                    </div>
                </div>
            );
        }

        // десктопная таблица
        return (
            <div className="table-responsive">
                <Table striped bordered hover size="sm" className="w-100 ms-3 mt-1 mb-1" style={{ maxWidth: '98%', lineHeight: '14px' }}>
                    <thead>
                    <tr className={"small text-nowrap"}>
                        <th className="small fst-italic text-muted">Date</th>
                        <th className="small fst-italic text-muted">Type</th>
                        <th className="small fst-italic text-muted">Description</th>
                        <th className="small fst-italic text-muted text-center">Amount</th>
                        <th className="small fst-italic text-muted text-center">Fee</th>
                        <th className="small fst-italic text-muted text-center">Net</th>
                        <th className="small fst-italic text-muted text-center">Plan</th>
                        <th className="small fst-italic text-muted text-center">%</th>
                        <th className="small fst-italic text-muted text-center">Reward</th>
                    </tr>
                    </thead>
                    <tbody>
                    {logs.map(log => (
                        <tr key={log.id} className="small text-nowrap">
                            <td className="text-muted fst-italic">{formatDate(log.user_transaction_date)}</td>
                            <td className="text-muted fst-italic">{log.user_transaction_type}</td>
                            <td className="text-muted fst-italic text-nowrap" style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '250px'
                            }}>{log.reward_description}</td>
                            <td className="text-muted fst-italic text-center">${log.total_amount?.toFixed(2)}</td>
                            <td className="text-muted fst-italic text-center">${log.stripe_fee?.toFixed(2)}</td>
                            <td className="text-muted fst-italic text-center">${log.net_amount?.toFixed(2)}</td>
                            <td className="text-muted fst-italic text-center">{log[planKey] || '-'}</td>
                            <td className="text-muted fst-italic text-center">{log[rewardPercentKey]?.toFixed(2) || '0.00'}%</td>
                            <td className="text-muted fst-italic text-center">${log[rewardKey]?.toFixed(2) || '0.00'}</td>
                        </tr>
                    ))}

                    <tr className="fw-bold text-success small">
                        <td className="small text-muted fst-italic">TOTAL:</td>
                        <td colSpan={7}></td>
                        <td className="small text-muted fst-italic text-center">${totalReward.toFixed(2)}</td>
                    </tr>
                    </tbody>
                </Table>
            </div>
        );
    };

    return (
        <div className="p-3 rounded ">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 gap-2">
                <h6 className="text-success mb-0">Your Referral Tree (L1, L2, L3)</h6>

                <Button
                    variant="outline-success"
                    size="sm"
                    className="mb-0"
                    onClick={fetchData}
                >
                    <FaSyncAlt className="me-2" style={{ position: 'relative', top: '-2px' }} />
                    Refresh Data
                </Button>
            </div>
            <p className="text-muted small mb-3">
                This section shows all users you’ve referred to the system – they are your first level (L1). Each of them can refer new users, who will be part of the second level (L2), and so on. You can view the full referral chain and see details for each user.
            </p>




            {user?.user?.username && (
                <div className="mb-0 d-flex align-items-center">
                    <h5 className="me-2"> <FaUser className="text-success" style={{ position: 'relative', top: '-2px', fontSize: '0.85em' }} /></h5>
                    <h5 className="fw-bold text-success">{user?.user?.username}</h5>
                    <h5 className="ms-2 text-muted">(You)</h5>
                </div>
            )}

            {loading ? (
                <Loader />
            ) : data.length === 0 ? (
                <div className="text-muted small fst-italic ms-2 mt-2">
                    Unfortunately, you have no referrals yet.
                </div>
            ) : (
                data.map((level1, i) => (
                    <div key={i} className="mb-0 ms-3">
                        <div className="d-flex align-items-center">
                         <span
                           className="text-success fw-bold"
                               onClick={() => toggleUserBranch(`L1-${i}`)}
                               style={{ cursor: 'pointer' }}
                                      >
                               {expandedUsers[`L1-${i}`] ? '−' : '+'} <FaUser className="text-success" style={{ position: 'relative', top: '-1px', fontSize: '0.99em' }} />{' '}
                             <span className="small">{level1.user.username.slice(0, 4)}</span>
                        </span>
                            {isMobile ? (
                            <span className="small text-muted ms-2 fst-italic">
                                 L1-{level1.attractedCount_l2}
                             </span>
                        ) : (
                            <span className="text-success small ms-1 text-muted fst-italic">
                                  – L1 user, attract <strong>{level1.attractedCount_l2}</strong> user{level1.attractedCount_l2 === 1 ? '' : 's'} to L2.
                             </span>
                        )}


                            <span
                                className="fw-bold text-muted"
                                onClick={() => toggleLogs(`L1-${i}`)}
                                style={{ cursor: 'pointer', marginLeft: '20px', position: 'relative', top: '-1px' }}
                            >
  {expandedLogs[`L1-${i}`] ? '−' : '+'}{' '}
                                <FaTable
                                    className="text-success fw-bold me-1"
                                    style={{ position: 'relative', top: '-2px', fontSize: '0.99rem' }}
                                />

                                {isMobile ? (
                                    <span className="small text-muted">
      {level1.totalCount}, ${calculateTotalReward(level1.logs, 1)}
    </span>
                                ) : (
                                    <>
      <span className="small">
        {level1.totalCount} log record{level1.totalCount === 1 ? '' : 's'} (view).
      </span>
                                        <span className="small text-muted ms-2 fst-italic">
        Registered:{' '}
                                            {(() => {
                                                const d = new Date(level1.user.createdAt);
                                                const day = String(d.getDate()).padStart(2, '0');
                                                const month = d.toLocaleString('en-US', { month: 'short' });
                                                const year = d.getFullYear();
                                                return `${day}-${month}-${year}`;
                                            })()}
                                            , Reward from user: ${calculateTotalReward(level1.logs, 1)}
      </span>
                                    </>
                                )}
</span>


                        </div>
                        <Collapse in={expandedLogs[`L1-${i}`]}>
                            <div>{renderLogs(level1.logs, 1)}</div>
                        </Collapse>

                        <Collapse in={expandedUsers[`L1-${i}`]}>
                            <div>
                                {level1.level2.length > 0 ? (
                                    level1.level2.map((level2, j) => (
                                        <div key={j} className="ms-4">
                                            <div className="d-flex align-items-center">
                         <span
                            className="text-success fw-bold"
               onClick={() => toggleUserBranch(`L2-${i}-${j}`)}
      style={{ cursor: 'pointer' }}
  >
    {expandedUsers[`L2-${i}-${j}`] ? '−' : '+'}{' '}
      <FaUser className="text-info" style={{ position: 'relative', top: '-1px', fontSize: '0.99em' }} />
    <span className="small ms-1">↳ {level2.user.username.slice(0, 4)}</span>
  </span>

                                                {isMobile ? (
                                                    <span className="small text-muted ms-2 fst-italic">
    L2–{level2.attractedCount_l3}
  </span>
                                                ) : (
                                                    <span className="text-success small ms-1 text-muted fst-italic">
    – L2 user, attract <strong>{level2.attractedCount_l3}</strong> user{level2.attractedCount_l3 === 1 ? '' : 's'} to L3.
  </span>
                                                )}


                                                <span
                                                    className="fw-bold text-muted"
                                                    onClick={() => toggleLogs(`L2-${i}-${j}`)}
                                                    style={{ cursor: 'pointer', marginLeft: '20px', position: 'relative', top: '-1px' }}
                                                >
  {expandedLogs[`L2-${i}-${j}`] ? '−' : '+'}{' '}
                                                    <FaTable
                                                        className="text-info fw-bold me-1"
                                                        style={{ position: 'relative', top: '-2px', fontSize: '0.99rem' }}
                                                    />

                                                    {isMobile ? (
                                                        <span className="small text-muted">
      {level2.totalCount}, ${calculateTotalReward(level2.logs, 2)}
    </span>
                                                    ) : (
                                                        <>
      <span className="small">
        {level2.totalCount} log record{level2.totalCount === 1 ? '' : 's'} (view).
      </span>
                                                            <span className="small text-muted ms-2 fst-italic">
        Registered:{' '}
                                                                {(() => {
                                                                    const d = new Date(level2.user.createdAt);
                                                                    const day = String(d.getDate()).padStart(2, '0');
                                                                    const month = d.toLocaleString('en-US', { month: 'short' });
                                                                    const year = d.getFullYear();
                                                                    return `${day}-${month}-${year}`;
                                                                })()}
                                                                , Reward from user: ${calculateTotalReward(level2.logs, 2)}
      </span>
                                                        </>
                                                    )}
</span>

                                            </div>

                                            <Collapse in={expandedLogs[`L2-${i}-${j}`]}>
                                                <div>{renderLogs(level2.logs, 2)}</div>
                                            </Collapse>

                                            <Collapse in={expandedUsers[`L2-${i}-${j}`]}>
                                                <div>
                                                    {level2.level3.length > 0 ? (
                                                        level2.level3.map((level3, k) => (
                                                            <div key={k} className="ms-4">
                                                                <div className="d-flex align-items-center">
                                                            <span   onClick={() => toggleLogs(`L3-${i}-${j}-${k}`)} style={{ cursor: 'pointer' }}>
                                                              <FaUser className="text-warning" style={{ position: 'relative', top: '-2px', fontSize: '0.99em' }} />
                                                                 <span className="text-success small fw-bold ms-1">↳ ↳ {level3.user.username.slice(0,4)}</span></span>
                                                                    <span className="small text-muted fst-italic ms-1">L3 </span>
                                                                    <span
                                                                        className="fw-bold text-muted"
                                                                        onClick={() => toggleLogs(`L3-${i}-${j}-${k}`)}
                                                                        style={{ cursor: 'pointer', marginLeft: '20px', position: 'relative', top: '-1px' }}
                                                                    >
  {expandedLogs[`L3-${i}-${j}-${k}`] ? '−' : '+'}{' '}
                                                                        <FaTable
                                                                            className="text-warning fw-bold me-1"
                                                                            style={{ position: 'relative', top: '-2px', fontSize: '0.99rem' }}
                                                                        />

                                                                        {isMobile ? (
                                                                            <span className="small text-muted">
      {level3.totalCount}, ${calculateTotalReward(level3.logs, 3)}
    </span>
                                                                        ) : (
                                                                            <>
      <span className="small">
        {level3.totalCount} log record{level3.totalCount === 1 ? '' : 's'} (view).
      </span>
                                                                                <span className="small text-muted ms-2 fst-italic">
        Registered:{' '}
                                                                                    {(() => {
                                                                                        const d = new Date(level3.user.createdAt);
                                                                                        const day = String(d.getDate()).padStart(2, '0');
                                                                                        const month = d.toLocaleString('en-US', { month: 'short' });
                                                                                        const year = d.getFullYear();
                                                                                        return `${day}-${month}-${year}`;
                                                                                    })()}
                                                                                    , Reward from user: ${calculateTotalReward(level3.logs, 3)}
      </span>
                                                                            </>
                                                                        )}
</span>

                                                                </div>
                                                                <Collapse in={expandedLogs[`L3-${i}-${j}-${k}`]}>
                                                                    <div >{renderLogs(level3.logs, 3)}</div>
                                                                </Collapse>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="ms-4 text-muted small fst-italic">No level 3 referrals</div>
                                                    )}
                                                </div>
                                            </Collapse>
                                        </div>
                                    ))
                                ) : (
                                    <div className="ms-4 text-muted small fst-italic">No level 2 referrals</div>
                                )}
                            </div>
                        </Collapse>
                    </div>
                ))
            )}
            <div className="text-muted small mt-3 mb-3">
                <div><strong>Expand / Collapse User Structure</strong> – To view the nested referral structure, click on a user icon or their name. This will reveal the next level (up to level 3). To collapse, click again.</div>
                <div><strong>Expand / Collapse Reward Logs</strong> – To see your earnings from a user’s payments, click the table icon next to their row. If they’ve made payments, you’ll see your rewards. Click the icon again to hide the log.</div>
            </div>
        </div>
    );
};

export default AffiliateLogsTree;
